<div class="p-6">
  @if (backgroundColorOptionAvailable$ | async) {
    <!-- show background color option -->
    <div class="mb-10">
      <div class="flex justify-between items-center">
        <div class="opacity-70">
          {{ 'page-config.background-color' | translate }}
        </div>
        <rk-switch
          [isChecked]="forceBackgroundColor"
          (switched)="onForceBackgroundColorChange($event)"
        ></rk-switch>
      </div>
      @if (forceBackgroundColor) {
        <!-- background color selector -->
        <div class="mt-3">
          <rk-color-selector
            (colorChange)="onBackgroundColorChange($event)"
            [initialColor]="backgroundColor$ | async"
          ></rk-color-selector>
        </div>
      }
    </div>
  }
  <rk-color-selector
    [parameter]="'page-config.header-text-color' | translate"
    (colorChange)="onHeaderTextColorChange($event)"
    [initialColor]="headerTextColor$ | async"
  ></rk-color-selector>
</div>
